<template>
  <!-- <el-dialog title="选择成员" :visible="addAVMemberModalVisible" @close="onClosed">
		<div class="member-list">
			<el-checkbox-group v-model="checkList" class="checkboxGroup" :max="6">
				<template v-for="item in groupMembers" >
					<el-checkbox
						:label="item.member||item.owner"
						:disabled="item.member == username || item.owner == username?true:false"
						class="checkbox"
						:key="item.member"
					>{{item.DisplayName || item.member||item.owner}}</el-checkbox>
				</template>
			</el-checkbox-group>
		</div>
		<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="startConference">开始</el-button>
		</span>
  </el-dialog> -->
	<my-dialog class="member-dialog" title="选择成员" :show="addAVMemberModalVisible" @close="onClosed" width="400px">
		<div class="member-list">
			<el-checkbox-group v-model="checkList" class="checkboxGroup" :max="6">
				<template v-for="item in groupMembers" >
					<el-checkbox
						:label="item.member||item.owner"
						:disabled="item.member == username || item.owner == username?true:false"
						class="checkbox"
						:key="item.member"
					>{{item.DisplayName || item.member||item.owner}}</el-checkbox>
				</template>
			</el-checkbox-group>
		</div>
		<span class="btn-group">
				<el-button class="btn-primary" type="primary" size="medium" @click="startConference">开始</el-button>
		</span>
	</my-dialog>
</template>


<script>
import { mapActions, mapGetters } from "vuex";
import MyDialog from '@/components/gkDialog.vue'
export default{
	components:{
		MyDialog
	},
	data(){
		return {
			dialogVisible: false,
			checkList: [],
		};
	},
	props: [
		"to"
	],
	computed: {
		groupMembers(){
			return this.$store.state.emedia.groupMembers;
		},
		multiAVModalVisible(){
			return this.$store.state.emedia.multiAVModalVisible;
		},
		confr(){
			return this.$store.state.emedia.confr;
		},
		addAVMemberModalVisible(){
			return this.$store.state.emedia.addAVMemberModalVisible;
		},
		username(){
			return this.$store.state.hxLoginId;
		}
	},   
	methods: {
		...mapActions([
			"showMultiAVModal",
			"hideMultiAVModal",
			"setConfr",
			"setAVMemeberModalVisible"
		]),
		show(){
			console.log("888888  show");
			this.$data.checkList = [this.username];
			// this.$data.dialogVisible = true
			this.setAVMemeberModalVisible({ addAVMemberModalVisible: true });
		},
		hide(){
			// this.$data.dialogVisible = false
			this.setAVMemeberModalVisible({ addAVMemberModalVisible: false });
		},
		onClosed(){
			this.$data.checkList = [this.username];
			this.hide();
		},
		startConference(){
			const me = this;
			let pwd = Math.random().toString(36).substr(2);
			if(me.multiAVModalVisible){
				// 发送邀请
				const appkey = me.$IM.config.appkey;
				const spHost = me.$IM.config.Host;
				const { confrId, password } = me.confr;
				const gid = me.to.groupid;
				let jids = [];

				for(let elem of me.$data.checkList){
					if(elem != me.$data.username){
						jids.push(appkey + "_" + elem + "@" + spHost);
					}
				}
				for(let jid of jids){
					me.$IM.call.inviteConference(confrId, password, jid, gid);
				}

				return this.hide();
			}
			this.showMultiAVModal();
			
			pwd = "";
			const videoSetting = JSON.parse(localStorage.getItem("videoSetting"));
			const recMerge = videoSetting && videoSetting.recMerge || false;
			const rec = (videoSetting && videoSetting.rec) || false;
			this.$IM.EMedia.mgr.createConference(me.$IM.EMedia.mgr.ConfrType.COMMUNICATION_MIX, pwd, rec, recMerge).then(function(confr){
				console.log("%c会议的信息", "color: red", confr); // 可以在这里拿到会议id confrId 来查服务端录制
				confr.type=10;//
				me.setConfr({ confr });
				const tkt = confr.ticket;
				me.$IM.EMService.joined(confr.confrId) || me.$IM.EMService.joinConferenceWithTicket(confr.confrId, tkt, "user ext field").then(function(){
					me.$IM.EMService.publish({ audio: true, video: true }, "user ext field")["catch"](function(e){
						console.error(e);
					});
				})["catch"](function(e){
					console.error(e);
				});

				// 发送邀请
				const appkey = me.$IM.config.appkey;
				const spHost = me.$IM.config.Host;
				const { confrId, password } = confr;
				const gid = me.to.groupid;
				let jids = [];
				for(let elem of me.$data.checkList){
					if(elem != me.$data.username){
						jids.push(appkey + "_" + elem + "@" + spHost);
					}
				}
				//发送会议邀请消息到群里
				let msgid=me.$IM.conn.getUniqueId();
				let msg=new me.$IM.message('txt',msgid);
				msg.set({
					msg:`邀请你加入会议,请点击加入:${confrId}`,
					to:gid,
					chatType:'groupChat',
					ext:{
						conferenceId:confrId,
						msg_extension:`{"inviter":${me.username},"group_id":${gid}`,
						password:password,
						groupId:gid,
						inviter:me.username,
					},
					roomType:false,
					success(id,serviceMsgId){
						console.log(id,serviceMsgId);
					},
					fail(){
						console.log('自定义消息发送失败');
					}
				})
				me.$IM.conn.send(msg.body);
				for(let jid of jids){
					me.$IM.call.inviteConference(confrId, password, jid, gid);
				}
			});
			return this.hide();
		}
	},
};
</script>

<style lang="scss">
.member-list{
	overflow-y: auto;
	max-height: 500px;
	.checkbox{
		display: block;
		padding: 5px 0;
		border-bottom: 1px solid rgb(242, 242, 242);
	}
}
.member-dialog{
	.dialog-container{
		transform: translate(-50%, -60%);
	}
	.dialog-head{
		background-color: #fff;
		border-bottom: 1px solid #e5e5e5;
		height: auto;
		.dialog-title{
			color: #333;
		}
	}
	.icon-close{
		color: #ccc;
	}
	.btn-group{
		display: block;
		margin-top: 20px;
		text-align: right;
		.btn-primary {
			border: none;
		}
	}
}

</style>
